import L from "leaflet";
import { useEffect } from "react";
import { Marker, useMap, useMapEvents } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import MarkerImg from "_assets/imgs/marker1.svg";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { obterPlanoDiretorNoPonto } from "store/modules/consultaprevia/actions/obterPlanoDiretorNoPonto";
import { useCamadas } from "../contexts/CamadasProvider";

const iconePonto = new L.Icon({
  iconUrl: MarkerImg,
  iconSize: [20, 20],
  iconAnchor: [10, 15]
});

/**
 * Clique no mapa = pergunta ao plano diretor o que vale naquela coordenada.
 * O marcador fica onde o cidadão clicou, para a resposta na lateral continuar
 * ancorada em um ponto visível.
 */
export const ConsultaPorPonto = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const map = useMap();
  const { fichaAberta } = useCamadas();

  const { ponto } = useTypedSelector(
    (state) => state.consultaprevia.obterPlanoDiretorNoPonto
  );

  // O mapa inteiro é alvo de clique aqui, então o cursor precisa dizer isso.
  // A classe já existe no CSS do organismo Map e é a mesma que o ZoomBox usa.
  useEffect(() => {
    const container = map.getContainer();
    L.DomUtil.addClass(container, "crosshair-cursor-enabled");

    return () => L.DomUtil.removeClass(container, "crosshair-cursor-enabled");
  }, [map]);

  useMapEvents({
    click: (e) => {
      // Só navega quando há ficha ocupando a lateral. Navegar a cada clique
      // empilhava uma entrada de histórico por consulta, e o botão Voltar do
      // navegador passava a exigir um clique por ponto consultado.
      if (fichaAberta) navigate("/consulta-previa");

      dispatch(
        obterPlanoDiretorNoPonto({
          latitude: e.latlng.lat,
          longitude: e.latlng.lng
        })
      );
    }
  });

  if (!ponto) return null;

  return (
    <Marker
      position={[ponto.latitude, ponto.longitude]}
      icon={iconePonto}
      interactive={false}
    />
  );
};
